/**************************************************
 * Nombre:       Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useContext, useEffect, useRef, useState} from "react";
import Tarjeta_Categoria from "./Tarjeta_Categoria";
import {ArrowRightAlt, KeyboardArrowLeft, KeyboardArrowRight} from "@mui/icons-material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {useNavigate} from "react-router";
import '@splidejs/react-splide/css';
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {contexApp} from "../../App";

const Categorias = () => {
    const {sCell, masSM} = useResponsive()
    const cData = useContext(contexApp)
    const refe = useRef()
    const [categorias, setCategorias] = useState([])
    const navigate = useNavigate()

    const siguiente = () => {
        refe.current.go('>')
    }

    const atras = () => {
        refe.current.go('<')
    }

    useEffect(() => {

        if (cData.categorias) {
            setCategorias(cData.categorias)
        }

    }, [cData]);
    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            size={12}
        >

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                size={12}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid item container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        size={12}
                    >

                        <Grid item container size={{xs: 4, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Typography
                                sx={{color: theme.palette.secondary.main, fontSize: sCell ? 26 : 38, fontWeight: 900}}
                            >Categorías</Typography>
                        </Grid>

                        <Grid item container size={{xs: 6, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-end', marginBottom: sCell ? 0 : -2}}>
                            <Button
                                onClick={() => navigate('/Portafolio')}
                                variant={'text'} color={'primary'} endIcon={<ArrowRightAlt/>}
                                sx={{color: theme.palette.primary.main, px: 1, py: 0.5}}>
                                Ver Catálogo
                            </Button>
                        </Grid>

                    </Grid>

                </Grid>

                {categorias && categorias.length > 0 &&
                    <Grid item container size={{xs: 12, sm: 12, md: 10}}
                          sx={{justifyContent: 'flex-start', marginTop: masSM ? 8 : 3}}>
                        <Splide
                            ref={refe}
                            aria-label="My Favorite Images" style={{width: '100%'}}
                            options={{
                                autoplay: true,
                                speed: 3000,
                                rewind: true,
                                perPage: sCell ? 3 : 5,
                                arrows: sCell,
                                gap: sCell ? 20 : 40,
                                pagination: false,
                                width: '100%',
                                drag: false,


                            }}
                        >
                            {categorias.map((item, index) => {
                                return (
                                    <SplideSlide key={`wr${index}`}>
                                        <Tarjeta_Categoria item={item}/>
                                    </SplideSlide>
                                )
                            })}


                        </Splide>
                    </Grid>
                }

                {!sCell &&
                    <Grid
                    container
                    justifyContent={'space-between'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}
                    sx={{mt: -26}}
                >

                    <IconButton
                        onClick={() => atras()}
                        sx={{
                            backgroundColor: theme.palette.secondary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.secondary.main + 80
                            }
                        }}>
                        <KeyboardArrowLeft sx={{fill: '#fff'}}/>
                    </IconButton>

                    <IconButton
                        onClick={() => siguiente()}
                        sx={{
                            backgroundColor: theme.palette.secondary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.secondary.main + 80
                            }
                        }}>
                        <KeyboardArrowRight sx={{fill: '#fff'}}/>
                    </IconButton>

                </Grid>
                }

            </Grid>


        </Grid>
    )

}
export default Categorias